module.exports = __webpack_public_path__ + "static/media/hierarquia.a4bfe52e.png";